import axios from 'axios';

const API_URL = process.env.REACT_APP_QL_API_SOCKET_URL || 'http://localhost:3000';

/**
 * Check if server health endpoint is responding
 * @returns {Promise<boolean>} true if server is healthy, false otherwise
 */
export const checkServerHealth = async () => {
  try {
    const healthEndpoint = `${API_URL}health`;
    const response = await axios.get(healthEndpoint, {
      timeout: 5000, // 5 second timeout for health check
    });

    // Server is healthy only if we get a successful response (200-299)
    return response.status >= 200 && response.status < 300;
  } catch (error) {
    // Server is down if we can't reach the health endpoint
    return false;
  }
};

